import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './report-web-vitals'
import { Amplify } from 'aws-amplify'
import resources from './resources'
import './index.scss'
import './init-i18n'
import './init-amplify-i18n'
import './init-moment'
import { Authenticator } from '@aws-amplify/ui-react'
import { BrowserRouter } from 'react-router-dom'

Amplify.configure(resources.connection)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <Authenticator.Provider>
      <BrowserRouter basename={process.env.REACT_APP_ROUTER_BASENAME}>
        <App />
      </BrowserRouter>
    </Authenticator.Provider>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
